import React, { PureComponent } from 'react';

export class InvestorSection extends PureComponent {
  render() {
    const { title, value } = this.props.content;
    return (
      <div className="invest-section">
        <h2 className="invest-section__title">{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: value }}></p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Investors/InvestorSection.js